<!--
Author: TangChen
Date: 2018-11-15
Desc: 投资者知识评测组件，由index.js 配置引入
-->
<template>
    <div :class="'view-knowledge-test view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <risk-ques v-if="knowledge.url" :data="knowledge" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import riskQues from "@/components/acctInfo/riskQues.vue";
export default {
    name: "KnowledgeTest",
    components: {
        riskQues
    },
    mixins: [mixin],
    data () {
        return {
            knowledge: {
                risk: false
            }
        };
    },
    mounted() {
        const info = this.$cache.getUser();
        if(info.knowledgetestflag && info.knowledgetestflag !== "0"){
            this.knowledge.url = "home";
        }else{
            this.knowledge.url = "invdataup";
        }
    },
    methods: {}
};
</script>
<style lang="scss">
  .view-knowledge-test {
    padding-bottom: 36px;
  }
</style>
